module.exports = __webpack_public_path__ + "img/itx-eco-hub-icon.e3809741.svg";